import { createContext, useState, useMemo, useEffect } from 'react';
import { getLanguage, AVAILABLE_LANGUAGES } from '../util/language-util';
import { AppContextType } from '../types/app-context-type';
import { useTranslation } from 'react-i18next';
import React from 'react'

export const AppContext = createContext<AppContextType>({
  language: '',
  setLanguage: () => {}
});

const AppContextProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(AVAILABLE_LANGUAGES[0]);

  useEffect(()=>{
    const detectedLanguage = getLanguage();
    setLanguage(detectedLanguage);
  }, []);

  useEffect(()=>{
    if (i18n.language != language) {
      try {
        i18n.changeLanguage(language);
      } catch (e) {return}
    }
  }, [language]);

  const value = useMemo<AppContextType>(() => ({
    language, setLanguage
  }), 
    [
      language, setLanguage
    ]
  );
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export default AppContextProvider;